// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleProduct_container__1mefV","loaderContainer":"SingleProduct_loaderContainer__3PwUp"};